import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  pushNotification =  'api/PushNotifications/PushNotification';

  constructor(private http: HttpClient) {}

  sendPushNotification(notification): Observable<any> {
    return this.http.post(this.pushNotification, notification);
  }
}
